import { useContext, useState } from "react";
import { Helmet } from "react-helmet-async";
import { AuthContext } from "../contexts/AuthContext";
import Modal from "../components/Modal/Modal";
import axios from "../utils/axios";
import "./css/profile-page.css";
import "../components/UserDetails/css/user-details.css";
import GuestUserIcon from "../components/Icons/GuestUser";
import CardEditor from "../components/CardEditor/CardEditor";

const Profile = () => {
  const { profileImage, username, email, handleSetProfileImage} = useContext(AuthContext);
  const [isModalOpened, setIsModalOpened] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const handleAvatarClick = () => {
    setIsModalOpened(true);
  };
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleCloseModal = () => {
    setIsModalOpened(false);
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!selectedFile) return;
    
    const formData = new FormData();
    formData.append("image", selectedFile);
    
    setUploading(true);
    setError("");
    
    try {
      const response = await axios.post("/images/set-profile", formData);
      handleSetProfileImage(response.data?.user?.profileImage);
      console.log(response.data);
      setSelectedFile(null);
    } catch (err) {
      setError(err.response?.data?.message || err.message);
    } finally {
      setUploading(false);
      setIsModalOpened(false);
    }
  };

  return (
    <div className="wrapper profile-page">
      <Helmet>
        <title>Your profile | Poker Planning</title>
        <meta name="description" content="Make it yours! Add a profile picture and upload your favorite images to style your cards just the way you like." />
        <meta property="og:title" content="Your profile | Poker Planning" />
      </Helmet>
      <div className="user-details">
        <div className="avatar" onClick={handleAvatarClick}>
          {profileImage ? <img src={profileImage} className="profile-image" /> : <GuestUserIcon />}
        </div>
        <div className="user-details-content">
          <h3>{username}</h3>
          <p>{email}</p>
        </div>
      </div>
      <Modal closeHandler={handleCloseModal} isOpened={isModalOpened}>
        <div className="change-profile">
          <h3>Change profile picture</h3>
          <input
            type="file"
            id="imageUpload"
            accept="image/*"
            style={{display: "none"}}
            className="button gray"
            onChange={handleFileChange}
          />
          <label htmlFor="imageUpload" className="button gray">
            Choose a file
          </label>
          <p>{selectedFile?.name}</p>
          <button className="button gray" onClick={handleUpload}>Upload</button>
          {uploading && "Uploading..."}
          {error}
        </div>
      </Modal>
      <CardEditor />
    </div>
  );
};

export default Profile;
